import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, PHONE_TEL, PHONE_DISPLAY } from "@/data/site";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.9 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${scrolled ? "bg-white/75 backdrop-blur-xl shadow-[0_8px_30px_rgba(230,0,126,0.08)]" : "bg-transparent"}`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Logo className="h-12 sm:h-14" />
        <nav className="hidden lg:flex items-center gap-10" aria-label="Ana menü">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} data-testid={`nav-${n.href.slice(1)}`} className="relative text-sm font-medium text-zinc-700 hover:text-[#e6007e] transition-colors duration-300 after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-grad-pink hover:after:w-full after:transition-[width] after:duration-300">
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={PHONE_TEL} data-testid="nav-call-button" className="btn-grad-dark hidden sm:inline-flex items-center gap-2 text-white text-sm font-semibold px-5 py-2.5 rounded-full">
            <Phone size={16} /> {PHONE_DISPLAY}
          </a>
          <button onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menü" className="lg:hidden w-11 h-11 rounded-full card-soft flex items-center justify-center text-[#1a1118]">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden mx-4 mb-4 rounded-3xl bg-white/95 backdrop-blur-xl border border-pink-200/50 shadow-[0_20px_50px_rgba(230,0,126,0.15)] p-6 flex flex-col gap-1"
            data-testid="mobile-menu"
          >
            {NAV.map((n) => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="py-3 px-4 rounded-xl text-base font-medium text-zinc-800 hover:bg-[#fff0f5] hover:text-[#e6007e] transition-colors">
                {n.label}
              </a>
            ))}
            <a href={PHONE_TEL} className="btn-grad-dark mt-3 inline-flex items-center justify-center gap-2 text-white font-semibold px-5 py-3.5 rounded-full">
              <Phone size={16} /> Hemen Ara
            </a>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
